import { render, staticRenderFns } from "./OrderItemsPerStatus.vue?vue&type=template&id=9bcebc44"
import script from "./OrderItemsPerStatus.vue?vue&type=script&lang=js"
export * from "./OrderItemsPerStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsPerStatus.vue?vue&type=style&index=0&id=9bcebc44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports